var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExploreplanticona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlnsSerif: "http://www.serif.com/",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.5 175.5",
    style: {
      enableBackground: "new 0 0 175.5 175.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t\n\t\t.st2{fill-rule:evenodd;clip-rule:evenodd;stroke:#000000;stroke-width:6.9979;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.691692,0,0,0.472753,212.24,456.374)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-127.7-639.5h-109l27.2-48.3h54.5L-127.7-639.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.957046,0,0,0.837551,32.7815,164.764)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.3-136.1c0-10-7.1-18.1-15.9-18.1H-12c-8.8,0-15.9,8.1-15.9,18.1v78c0,10,7.1,18.1,15.9,18.1h138.5 c8.8,0,15.9-8.1,15.9-18.1V-136.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.879546,0,0,0.879546,136.103,-66.5917)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-14.4,259.2c0-5.3-4.3-9.6-9.6-9.6h-64.8c-5.3,0-9.6,4.3-9.6,9.6c0,5.3,4.3,9.6,9.6,9.6h64.8 C-18.7,268.9-14.4,264.5-14.4,259.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreplanticona);
export default __webpack_public_path__ + "static/media/exploreplanticona.be5c597b7db05914360311fb765089b9.svg";
export { ForwardRef as ReactComponent };